module.exports = __webpack_public_path__ + "img/sld_abt_meter_dark.cb6c64b0.svg";